import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorBarContentSX: SxProps = {
	width: 'inherit',
	maxWidth: '1440px',
};
